export default __webpack_public_path__ + "static/media/menu-icon.db61d651.svg";